// extracted by mini-css-extract-plugin
export default {"description":"InternalAccessControlView_description__Pxq19","divider":"InternalAccessControlView_divider__WTXt+"};